<!--
 * @Author: zl
 * @Date: 2022-04-24 10:43:35
 * @LastEditTime: 2023-01-12 13:43:03
 * @LastEditors: zl
 * @Description: 投资管理
-->
<template>
	<div class="Management-layout filter-layout">
		<div class="filter-box mb10">
			<h3 class="text-center pdt10 mb20">
				东部新中心建设项目投资统计报表
				<el-tooltip effect="light"
							placement="bottom-start">
					<svg-icon icon-class="wenhao"
							  class="custom-svg"></svg-icon>
					<template slot="content">
						<div v-html="titleTip"></div>
					</template>
				</el-tooltip>
			</h3>
			<!-- 搜索内容区域 -->
			<el-form ref="searchForm"
					 :model="searchForm"
					 size="small"
					 label-width="100px">
				<el-row :gutter="10"
						type="flex"
						justify="space-between">
					<el-col :span="6">
						<el-form-item label-width="10">
							筛选时间统计: {{ filterTime }}
						</el-form-item>
					</el-col>
					<el-col :span="18"
							class="custom-item">
						<el-form-item label="选择时间"
									  prop="month"
									  style="width:375px">
							<el-date-picker v-model="searchForm.endDate"
											type="month"
											:clearable="false"
											format="yyyy年MM月"
											value-format="yyyy-MM"
											range-separator="~"
											start-placeholder="开始时间"
											end-placeholder="结束时间"
											placeholder="请选择月份"
											@change="monthChange"></el-date-picker>
						</el-form-item>
						<el-form-item label="单位："
									  label-width="70px">
							<el-radio-group v-model="searchForm.type"
											@change="changeMoneyUnit">
								<el-radio-button label="0">元</el-radio-button>
								<el-radio-button label="1">万元</el-radio-button>
								<el-radio-button label="2">亿元</el-radio-button>
							</el-radio-group>
						</el-form-item>
						<el-form-item label-width="0"
									  class="ml10">
							<el-button type="primary"
									   size="small"
									   icon="el-icon-menu"
									   @click="doFilter('top', '1098001')">列过滤</el-button>
							<el-button size="small"
									   @click="exportExcelMethod('total')">导出Excel</el-button>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<!-- 合计表格 -->
			<vxe-table align="center"
					   auto-resize
					   resizable
					   border
					   :data="tableObj.totalData"
					   highlight-current-row
					   highlight-hover-row
					   height="228px"
					   @cell-click="cellClick"
					   :cell-class-name="cellStyle"
					   :loading="tableObj.totalLoading"
					   ref="investTopTable"
					   show-header-overflow="tooltip"
					   show-overflow="tooltip">
				<vxe-column title="片区"
							field="typeName"
							width="100"></vxe-column>
				<vxe-column title="年度计划项目总投资(金额)"
							field="totalOutputValue"
							width="200">
					<template #default="{ row }">
						<span class="vxe-cell--label custom-cell">
							<strong>{{ row.totalOutputValue }}</strong>
						</span>
					</template>
				</vxe-column>
				<vxe-colgroup v-for="item in tableList"
							  :title="item.sname"
							  :key="item.id"
							  header-class-name="custom-table-height">
					<vxe-column v-for="n in item.children"
								:key="n.id"
								:title="n.sname"
								:field="n.field"
								:visible="n.visible"
								min-width="160"
								header-class-name="custom-table-height">
						<template #default="{ row }">
							<span class="vxe-cell--label custom-cell">
								<strong>{{ row[n.field] }}</strong>
							</span>
						</template>
					</vxe-column>
				</vxe-colgroup>
			</vxe-table>
		</div>
		<div class="filter-content primary-layout">
			<!-- 内容区域 提示信息 和 导出excel、列过滤 -->
			<div class="primary-header">
				<div class="left-text">
					<span class="tips">
						<i class="el-icon-warning"></i>
						<span v-html="customTip"></span>
					</span>
				</div>
				<div class="btnGroups">
					<el-input v-model="searchForm.sname"
							  size="small"
							  placeholder="请输入项目名称"
							  clearable
							  class="custom-input-inner">
						<el-button class="btn-success"
								   size="small"
								   slot="append"
								   @click="getInvestData">查询</el-button>
					</el-input>

					<!-- 弹出框搜素区域 -->
					<el-popover placement="bottom-end"
								width="415"
								trigger="click">
						<el-form ref="searchForm"
								 :model="searchForm"
								 size="small"
								 label-width="100px">
							<el-form-item label="项目类型"
										  prop="newProType">
								<el-select v-model="searchForm.newProType"
										   placeholder="请选择"
										   clearable>
									<el-option v-for="item in projectDict.dxxmlx"
											   :key="item.id"
											   :label="item.sname"
											   :value="item.value"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="建设单位"
										  prop="constructionUnit">
								<el-select v-model="searchForm.constructionUnit"
										   placeholder="请选择"
										   clearable>
									<el-option v-for="(item, index) in constructionUnitList"
											   :key="index"
											   :label="item.sname"
											   :value="item.ownerUnit"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="计划编排类别"
										  prop="start">
								<el-select v-model="searchForm.start"
										   placeholder="请选择">
									<el-option v-for="item in typeOptions"
											   :key="item.value"
											   :label="item.label"
											   :value="item.value"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="建设类型"
										  prop="constType">
								<el-select v-model="searchForm.constType"
										   placeholder="请选择"
										   clearable>
									<el-option v-for="item in projectDict.dxjslx"
											   :key="item.id"
											   :label="item.sname"
											   :value="item.value"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label-width="0"
										  class="text-center borderTop">
								<el-button type="primary"
										   icon="el-icon-search"
										   @click="submitForm">查询</el-button>
								<el-button icon="el-icon-refresh"
										   @click="resetForm">重置</el-button>
							</el-form-item>
						</el-form>
						<el-button type="success"
								   size="small"
								   slot="reference"
								   icon="el-icon-arrow-down"
								   class="ml10 mr10 btn-success"></el-button>
					</el-popover>
					<el-button type="primary"
							   size="small"
							   icon="el-icon-menu"
							   @click="doFilter('bottom', '1098002')">列过滤</el-button>
					<el-button size="small"
							   @click="exportExcelMethod('list')">导出Excel</el-button>
				</div>
			</div>
			<!-- 内容表格 -->
			<div class="primary-content mt10">
				<div class="w-table-layout">
					<vxe-table align="center"
							   auto-resize
							   resizable
							   border
							   ref="investTable"
							   :data="tableObj.data"
							   height="95%"
							   highlight-current-row
							   highlight-hover-row
							   :loading="tableObj.loading"
							   show-header-overflow="tooltip"
							   show-overflow="tooltip">
						<vxe-column title="序号"
									type="seq"
									width="65"></vxe-column>
						<vxe-column title="项目名称"
									field="projectName"
									header-align="center"
									align="left"
									min-width="150">
							<template #default="{ row }">
								<span class="vxe-cell--label blue-text"
									  @click="enterProject(row)">
									{{ row.projectName }}
								</span>
							</template>
						</vxe-column>
						<vxe-column title="片区"
									field="isNorthName"
									width="100"></vxe-column>
						<vxe-column title="建设单位"
									field="constructionUnitName"
									min-width="150"
									header-align="center"
									align="left">
							<template #default="{ row }">
								<el-tooltip effect="dark"
											:content="row.constructionUnitName"
											placement="top">
									<span class="vxe-cell--label">{{ row.constructionUnitShortName }}</span>
								</el-tooltip>
							</template>
						</vxe-column>
						<vxe-column title="计划编排类别"
									field="planningCategory"
									width="120"></vxe-column>
						<vxe-column title="项目类型"
									field="proTypeName"
									width="120px"></vxe-column>
						<vxe-column title="建设类型"
									field="constructionTypeName"
									width="120px"></vxe-column>
						<vxe-column title="争取开工年份"
									field="striveStartDate"
									width="120px"></vxe-column>
						<vxe-column title="项目总投资"
									field="proTotalValue"
									header-align="center"
									align="right"
									width="120"
									:visible="false"></vxe-column>
						<vxe-column title="年度计划项目总投资"
									field="totalOutputValue"
									header-align="center"
									align="right"
									width="160"></vxe-column>
						<vxe-colgroup v-for="item in tableList"
									  :title="item.sname"
									  :key="item.id"
									  header-class-name="custom-table-height">
							<vxe-column v-for="n in item.children"
										:key="n.id"
										:title="n.sname"
										:field="n.field"
										:visible="n.visible"
										header-align="center"
										align="right"
										header-class-name="custom-table-height"
										width="150"></vxe-column>
						</vxe-colgroup>
						<vxe-column title="操作"
									width="150">
							<template #default="{ row }">
								<el-button type="primary"
										   round
										   plain
										   class="table-btn"
										   v-if="roleBtns.includes('enter')"
										   @click="enterProject(row)">
									<svg-icon icon-class="form-enter"></svg-icon> 进入项目
								</el-button>
							</template>
						</vxe-column>
					</vxe-table>
				</div>
			</div>
		</div>

		<!-- 列过滤 -->
		<ColumnFilter ref="ColumnFilter"
					  v-if="showFilter"
					  :filterColumns="filterColumns"
					  leftWidth="70px"
					  :customDialog="customDialog"
					  :busType="busType"
					  memory
					  @onFilter="onFilter"></ColumnFilter>
	</div>
</template>

<script>
import * as ProjectApi from 'api/projectManage/ProjectIndex'
import * as API from 'api/Investment/InvestmentIndex'
import ColumnFilter from '@/views/Common/ColumnFilter'
import { mapState } from 'vuex'
import { getContainerParams } from '@/api/home/homeIndex'
import { exportExcel } from 'utils/tools'
import * as HomeApi from '@/api/home/homeIndex'
export default {
	name: 'ManagementIndex',
	components: { ColumnFilter },
	data() {
		return {
			// 搜索条件区域
			searchForm: {
				selectDateType: 2,
				area: '', //区域
				month: '', //月份
				startDate: '', //选择开始时间
				endDate: '', //选择结束时间
				type: '1', // 金额单位 元 万元
				sname: '', //工程项目名称
				newProType: '', //项目类型
				start: '', //计划编排类别0 新建项目、1 开展前期、2 续建项目
				constructionUnit: '', //建设单位
				constType: '', //建设类型
				cellType: '', //单元格
				areaType: '', //区域码表
			},
			filterTime: '', //筛选时间统计
			tableObj: {
				data: [], //详细表格数据
				loading: false, //详细表格数据loading
				totalData: [], //合计表格数据
				totalLoading: false, //合计表格数据loading
			},
			constructionUnitList: [], //建设单位列表
			showFilter: false, //列过滤弹窗显隐
			// 列过滤内容
			filterColumns: [
				{
					title: '',
					checkAll: false,
					columns: [],
				},
			],
			// 列过滤内容
			filterColumns1: [
				{
					title: '',
					checkAll: false,
					columns: [],
				},
			],
			customDialog: {
				visible: true,
				title: '列过滤',
				width: '1200px',
			},
			patrolUnitList: [], //三巡单位
			selectRowIndex: 0, // 点击单元格的rowIndex
			selectColumnIndex: 1, // 点击单元格的columnIndex
			selectField: '', //点击单元格的 field
			filterRow: {}, //点击的当前行
			filterColumn: {}, //点击的当前列
			busType: '', //用以区分略过滤模块
		}
	},
	created() {
		// 获取当前时间(后台)
		this.getContainerParams()
		// 根据单位类型查询单位
		this.getCompanyList()
		// 获取自定义列过滤 投资管理合计表
		this.getSelfData('1098001', false)
		// 获取自定义列过滤 投资管理项目表
		this.getSelfData('1098002', false)
	},
	methods: {
		/**
		 * @description: 准备工作
		 */

		// 获取当前时间(后台)
		getContainerParams() {
			getContainerParams({}).then((res) => {
				let endDate = res.data.currentDate.substr(0, 10)
				let startDate = endDate.substr(0, 4) + '-01-01'
				this.searchForm.month = [startDate, endDate]
				this.searchForm.startDate = startDate
				this.searchForm.endDate = endDate
				if (this.projectDict && this.projectDict.xmgsqy) {
					this.searchForm.area = this.projectDict.xmgsqy
						.map((x) => x.value)
						.join(',')
				}
				// 获取投资管理统计表格数据
				this.getInvestTotalData(true)
				this.filterTime =
					startDate.substr(0, 7) + ' 至 ' + endDate.substr(0, 7)
			})
		},

		// 获取自定义列过滤数据
		getSelfData(busType, first) {
			let params = { busType }
			let loadingName = busType == '1098001' ? 'totalLoading' : 'loading'
			let refName =
				busType == '1098001' ? 'investTopTable' : 'investTable'
			if (first) {
				this.tableObj[loadingName] = true
			}
			HomeApi.getSelfData(params)
				.then((res) => {
					if (res.data.length == 0) {
						return
					}
					if (this.$refs[refName]) {
						let tableShowColumn =
							this.$refs[refName].getTableColumn()
						tableShowColumn.fullColumn.forEach((x) => {
							let obj = res.data.find(
								(y) => y.field == x.property
							)
							if (obj) {
								x.visible = obj.isChecked
							}
						})
						this.$refs[refName].refreshColumn()
					}
					if (first) {
						this.tableObj[loadingName] = false
						this.getInvestTotalData(true)
					}
				})
				.catch(() => {
					this.tableObj[loadingName] = false
				})
		},

		// 获取投资管理统计表格数据
		getInvestTotalData(first) {
			let params = this.$utils.clone(this.searchForm, true)
			delete params.month
			let obj = {
				area: params.area,
				startDate: params.startDate,
				endDate: params.endDate,
				type: params.type,
			}
			this.tableObj.totalLoading = true
			API.getInvestmentTotalPage(obj)
				.then((res) => {
					this.tableObj.totalData = res.data.payVoList
					this.tableObj.totalLoading = false
					this.filterRow = this.$utils.clone(
						res.data.payVoList[0],
						true
					)
					if (first) {
						// 锁定 瑶海区 合计单元格 并清空 当前操作的filed
						this.selectField = 'totalOutputValue'
						let column = this.$refs.investTopTable.getColumnByField(
							this.selectField
						)
						this.filterColumn = column
						this.selectRowIndex = 0
						this.selectColumnIndex = 1
						this.searchForm.cellType = 0
						this.searchForm.areaType = this.filterRow.type
					}
					// 获取投资管理表格数据 和 统计表格
					this.getInvestData()
				})
				.catch(() => {
					this.tableObj.totalLoading = false
				})
		},

		// 获取投资管理表格数据
		getInvestData() {
			let params = this.$utils.clone(this.searchForm, true)
			delete params.month
			this.tableObj.loading = true
			API.getInvestmentManage(params)
				.then((res) => {
					this.tableObj.data = res.data.payVos
					this.tableObj.loading = false
				})
				.catch(() => {
					this.tableObj.loading = false
				})
		},

		// 根据单位类型查询单位
		getCompanyList() {
			ProjectApi.selectSysTenantsByType().then((res) => {
				this.$set(this, 'constructionUnitList', res.data.SUBJECT_JSDW)
			})
		},

		/**
		 * @description: 搜索区域操作
		 */

		// 时间change
		monthChange(data) {
			if (!data) {
				this.searchForm.startDate = ''
				this.searchForm.endDate = ''
				this.filterTime = ''
			} else {
				this.searchForm.endDate = data + '-01'
				this.searchForm.startDate = data.substr(0, 4) + '-01-30'
				this.filterTime = data.substr(0, 4) + '-01' + ' 至 ' + data
			}
			this.getInvestTotalData(true)
		},

		// money 单位change
		changeMoneyUnit() {
			// 获取投资管理统计表格数据
			this.getInvestTotalData()
		},

		// 表单搜索
		submitForm() {
			this.getInvestData()
		},

		// 重置表单
		resetForm() {
			this.$refs.searchForm.resetFields()
			this.searchForm.sname = ''
			this.getInvestData()
		},

		// 点击列过滤
		doFilter(type, busType) {
			this.$set(this, 'busType', busType)
			this.handlerField(type)
			setTimeout(() => {
				this.$refs.ColumnFilter.dialogObj.visible = true
			}, 300)
		},

		// 处理列过滤数据
		handlerField(type) {
			// 根据 type 区别 获取那个表格的列
			let refName = type == 'top' ? 'investTopTable' : 'investTable'
			this.showFilter = true
			let tableColumn = this.$refs[refName].getTableColumn()
			let arr = tableColumn.collectColumn
			// 用以获取不同分组表头名 因为名字相同 要用分组表头区分
			let index2 = type == 'top' ? 2 : 3
			let index1 = type == 'top' ? 1 : 2
			let parentId1 = arr[arr.length - index1].id
			let parentId2 = arr[arr.length - index2].id
			let filterColumn = this.$utils.clone(tableColumn.fullColumn, true)
			if (type == 'bottom') {
				filterColumn.shift()
				filterColumn.pop()
			} else {
				filterColumn.shift()
				filterColumn.shift()
			}
			filterColumn.forEach((x) => {
				if (x.parentId == parentId1) {
					x.title = '本月' + x.title
				}
				if (x.parentId == parentId2) {
					x.title = '截止当月累计' + x.title
				}
			})
			this.filterColumns[0].columns = filterColumn
		},

		// 确认列过滤
		onFilter(arr) {
			let refName =
				this.busType == '1098001' ? 'investTopTable' : 'investTable'
			let loadingName =
				this.busType == '1098001' ? 'totalLoading' : 'loading'
			this.tableObj[loadingName] = true
			if (this.$refs[refName]) {
				this.$set(this, 'filterColumns', arr)
				this.getSelfData(this.busType, true)
				return
			}
			this.tableObj[loadingName] = false
		},

		/**
		 * @description: 表格相关操作
		 */

		// 单元格被点击触发事件
		cellClick({ row, rowIndex, column, columnIndex }) {
			let field = column.field
			if (field == 'typeName') {
				return
			}
			// 保存当前行数据用来渲染中间的提示信息
			this.filterRow = this.$utils.clone(row, true)
			this.filterColumn = this.$utils.clone(column, true)

			// 保存 点击单元的 行下标 和 列下标 用来渲染 active 的样式
			this.selectRowIndex = rowIndex
			this.selectColumnIndex = columnIndex

			//存储点击单元格的field
			this.selectField = field

			// 获取区域码表
			this.searchForm.areaType = row.type

			// 获取单元格
			let filterData = this.$utils.filterTree(
				this.tableList,
				(item) => item.field == field
			)
			if (filterData.length > 0) {
				this.searchForm.cellType = filterData[0].index
			} else {
				if (columnIndex == 1) {
					this.searchForm.cellType = 0
				} else {
					return
				}
			}

			// 根据点击的单元格获取不同的 moduleType 在调取借口
			this.getInvestData()
		},

		// 指定单元格赋予样式
		cellStyle({ rowIndex, column, columnIndex }) {
			if (
				rowIndex === this.selectRowIndex &&
				columnIndex === this.selectColumnIndex &&
				column.parentId == this.filterColumn.parentId
			) {
				return 'custom-active-cell'
			}
		},

		// 进入项目
		enterProject(data) {
			if (!this.roleBtns.includes('enter')) {
				return
			}
			let url = this.$outUrl
			let token = this.$getSessionItem('token')
			let tenantId = this.$getSessionItem('tenantId')
			let limitId = this.$getSessionItem('limitId')
			ProjectApi.getAuditWorkPower({
				projectId: data.projectId,
			}).then((res) => {
				if (res.operationCode == 1 && res.msg == 'faild') {
					this.$message.warning(res.data)
					return
				}
				window.open(
					`${url}/DxAuditWork/#/main?projectId=${data.projectId}&token=${token}&tenantId=${tenantId}&limitId=${limitId}&isDataRole=${res.data}`,
					'_blank'
				)
			})
		},

		// 导出excel
		exportExcelMethod(type) {
			let params1 = this.$utils.clone(this.searchForm, true)
			let tableData =
				type == 'list' ? this.tableObj.data : this.tableObj.totalData
			let params = {
				selectYear: this.filterTime, //统计时间
				excelData: tableData, //导出数据集合
				type: params1.type,
			}

			let baseUrl =
				type == 'list'
					? '/auditschedule/exportInvestManageUpperExcel'
					: '/auditschedule/exportInvestManageExcel'
			let url = process.env.VUE_APP_BASE_URL + baseUrl
			let fileName =
				type == 'list'
					? '东部新中心建设项目投资管理列表'
					: '东部新中心建设项目投资管理报表统计'
			exportExcel(url, params, fileName)
		},
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),

		...mapState('user', {
			userInfo: (state) => state.userInfo,
		}),

		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),

		// 计划编排类别
		typeOptions() {
			let arr = [
				{
					label: '新建项目',
					value: '1',
					id: '100086',
				},
				{
					label: '开展前期',
					value: '2',
					id: '100087',
				},
				{
					label: '续建项目',
					value: '3',
					id: '100088',
				},
			]
			return arr
		},

		// 表格展示数据
		tableList() {
			let arr = [
				{
					sname: '截止当月累计',
					id: '1000001',
					children: [
						{
							sname: '计划完成产值',
							field: 'completedOutputValue',
							id: '1000001001',
							index: 1,
						},
						{
							sname: '施工申报产值',
							field: 'totalDeclareOutputValue',
							id: '1000001002',
							index: 2,
						},
						{
							sname: '拆迁等其他申报产值',
							field: 'totalDemolitionOtherDeclareValue',
							id: '1000001003',
							index: 3,
						},
						{
							sname: '施工审核产值',
							field: 'totalPeroidOutputValue',
							id: '1000001004',
							index: 4,
							visible: false,
						},
						{
							sname: '拆迁等其他审核产值',
							field: 'totalDemolitionOtherOutputValue',
							id: '1000001005',
							index: 5,
							visible: false,
						},
						{
							sname: '实际付款',
							field: 'totalExamineOutputValue',
							id: '1000001006',
							index: 6,
						},
					],
				},
				{
					sname: '本月',
					id: '1000002',
					children: [
						{
							sname: '计划完成产值',
							field: 'monthdOutputValue',
							id: '1000002007',
							index: 7,
						},
						{
							sname: '施工申报产值',
							field: 'declareOutputValue',
							id: '1000001008',
							index: 8,
						},
						{
							sname: '拆迁等其他申报产值',
							field: 'demolitionOtherDeclareValue',
							id: '1000001009',
							index: 9,
						},
						{
							sname: '施工审核产值',
							field: 'peroidOutputValue',
							id: '1000001010',
							index: 10,
							visible: false,
						},
						{
							sname: '拆迁等其他审核产值',
							field: 'demolitionOtherOutputValue',
							id: '1000001011',
							index: 11,
							visible: false,
						},
						{
							sname: '实际付款',
							field: 'examineOutputValue',
							id: '1000001012',
							index: 12,
						},
					],
				},
			]
			return arr
		},

		// 处理提示语
		customTip() {
			let msg = ''
			if (!!this.selectField) {
				// 片区
				let area = this.filterRow.typeName
				// 类名
				let formName = '年度计划项目总投资'
				// 项目数
				let total = this.tableObj.data.length
				// 金额
				let moneyTotal =
					this.tableObj.totalData[this.selectRowIndex][
						this.selectField
					]
				// 获取类名
				let filterData = this.$utils.filterTree(
					this.tableList,
					(item) => item.field == this.selectField
				)
				if (filterData.length > 0) {
					formName = filterData[0].sname
					// 分类 截止当月累计  和   本月
					let dateName = [1, 2, 3].includes(filterData[0].index)
						? '截止当月累计'
						: '本月'
					formName = dateName + formName
				}
				// 金额单位
				let unitObj = {
					0: '元',
					1: '万元',
					2: '亿元',
				}
				let unit = unitObj[this.searchForm.type]
				// 返回统计信息
				msg =
					`统计期内${area}${formName}${moneyTotal}${unit}
				<span class="ml15 mr15"> </span>` + `项目数：${total}个`
			}

			return msg
		},

		// 标题旁边的提示语
		titleTip() {
			let msg = `数据统计说明：默认展示本年度累计到当前月份数据统计，当选择其他年月数据时，则展示其他年度累计到结束月份数据统计。
						</br>
						</br>
						本年度项目：有计划开竣工时间，且时间范围在本年度的，无实际竣工时间都纳入本年度项目统计。
						有计划开竣工时间，且实际竣工时间为本年度的，本年纳入统计，第二年不统计。
						</br>
						</br>
						截止当月累计：
						初始统计：从本年度的开始月份到当前月份计算。
						当选择结束月份为其他年月时，则为从其年份的开始月份到其年份的结束月份计算。`
			return msg
		},
	},
}
</script>
<style lang='less' scoped>
.Management-layout {
	height: 100%;
	.pdb20 {
		padding-bottom: 20px !important;
	}
	.tips {
		color: #e6a23c;
		font-size: 16px;
	}
	.custom-svg {
		color: #888;
	}
	.custom-item {
		display: flex;
		justify-content: flex-end;
	}
	.custom-cell {
		font-size: 16px;
		cursor: pointer !important;
	}
	.custom-cell:hover {
		color: #27a9ff;
	}
}
</style>